// src/components/resumo/annotations/rangeOffset.ts
// 🎯 Calcular offset absoluto a partir de Range (VERSÃO CORRETA)

export const getAbsoluteOffsetFromRange = (
    container: HTMLElement,
    range: Range
): { absoluteStart: number; absoluteEnd: number } => {
    let absoluteStart = 0;
    let absoluteEnd = 0;

    let foundStart = false;
    let foundEnd = false;

    const walker = document.createTreeWalker(
        container,
        NodeFilter.SHOW_TEXT,
        {
            acceptNode: (node: Node) => {
                // Não contar caracteres do badge de comentário no offset
                const parent = node.parentElement;
                if (parent?.classList?.contains('highlight-comment-badge')) {
                    return NodeFilter.FILTER_REJECT;
                }
                return NodeFilter.FILTER_ACCEPT;
            }
        }
    );

    let node: Node | null;

    while ((node = walker.nextNode())) {
        const len = node.textContent?.length || 0;

        // ✅ Calcular start
        if (!foundStart) {
            if (node === range.startContainer) {
                absoluteStart += range.startOffset;
                foundStart = true;
            } else {
                absoluteStart += len;
            }
        }

        // ✅ Calcular end (INDEPENDENTE do start)
        if (!foundEnd) {
            if (node === range.endContainer) {
                absoluteEnd += range.endOffset;
                foundEnd = true;
            } else {
                absoluteEnd += len;
            }
        }

        // ✅ Parar quando encontrar ambos
        if (foundStart && foundEnd) break;
    }

    return { absoluteStart, absoluteEnd };
};